import React from 'react'

import { ColumnRank, ColumnBib, ColumnName, ColumnNoc, ColumnResult, ColumnDifference, ColumnExpander } from "components/common/TableColumns"
import { ColumnIntermediateRank, ColumnIntermediateDistance, ColumnIntermediateTime, ColumnIntermediateDiff } from "components/common/TableColumnsIntermediates"
import { hasConfig } from "components/sports/crd/helper/CrdHelpers"

export function TableColumnsLive(columnsAdded) {
    return (
        [
            ColumnIntermediateRank({ hasIrm: false }),
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnIntermediateDistance({ config: columnsAdded }),
            ColumnIntermediateTime({}),
            ColumnIntermediateDiff({}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsLiveSM(columnsAdded) {
    return (
        [
            ColumnIntermediateRank({ hasIrm: false }),
            ColumnBib({ label: "HeaderNumber" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnIntermediateDistance({ config: columnsAdded }),
            ColumnIntermediateTime({}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsFinish() {

    return (
        [
            ColumnRank({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "HeaderTime" }),
            ColumnDifference({}),
            ColumnExpander({ type: 'extendedResults' })
        ]
    )
}

export function TableColumnsFinishSM() {

    return (
        [
            ColumnRank({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "HeaderTime" }),
            ColumnExpander({ type: 'extendedResults' })
        ]
    )
}